import { filter } from 'ramda';

import { Tooth } from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';

import { toothHasReportID } from './isToothReportIDEquals';

export const filterTeethByReportID = (teeth: Tooth[], reportID: string) =>
  filter<Tooth>(toothHasReportID(reportID))(teeth);
